/* eslint-disable max-len */
import Question from 'images/coin-pages/questions/imx.svg'

import { blogCards, commonSlidesData } from 'pages/loans/[coin]/assets/page-data/commonPageData'

import { ICoinPageData } from '../types'

export const imxPage: ICoinPageData = {
  title: 'coin_531',
  description: 'coin_532',
  // description: 'coin_533',
  h1: (t, _, replacePlaceholders) => (
    <span
      dangerouslySetInnerHTML={{ __html: replacePlaceholders(t('get_instant_coin_loan'), { coin: 'Immutable (IMX)' }) }}
    />
  ),
  questionsBlock: {
    image: Question,
    questions: [
      {
        title: 'coin_534',
        answer: 'coin_535',
      },
      {
        title: 'coin_536',
        answer: 'coin_537',
      },
      {
        title: 'coin_538',
        answer: 'coin_539',
      },
      {
        title: 'coin_540',
        answer: 'coin_541',
      },
    ],
  },
  whatIs: {
    ...commonSlidesData('Immutable (IMX)'),
    text: [],
    paragraphs: [
      {
        title: 'coin_542',
        text: ['coin_544'],
      },
      {
        title: 'coin_543',
        text: ['coin_545'],
      },
    ],
    blogCards: [blogCards.borrowLikePro, blogCards.cryptoCrash],
  },
}
